import { types } from "../action-types";

const initialState = {
  loading: false,
  description: null,
  error: null,
};

export const writeWithAiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.WRITE_WITH_AI_INIT:
      return { ...state, loading: true, error: null };
    case types.WRITE_WITH_AI_SUCCESS:
      return { ...state, loading: false, description: action.payload };
    case types.WRITE_WITH_AI_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
